import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import * as React from "react";
import theme from "../../theme";
import { useLocation } from "react-router-dom";
import ReimbursementPhysicalVoucher from "../finance/ReimbursementPhysicalVoucher";
import { Evoucher } from "./Evoucher";
import CutOffDate from "./CutOffDate";
import Earnings from "../merchant/Earnings";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

export function Finance() {
  const { getUserPermission: getPhysicalVoucherPermission } =
    usePermissionGetter("finance", "reimbursment_physical_voucher");
  const { getUserPermission: getEvoucherPermission } = usePermissionGetter(
    "finance",
    "reimbursment_evoucher"
  );
  const { getUserPermission: getSalesListingPermission } = usePermissionGetter(
    "finance",
    "sales_listing"
  );
  const { getUserPermission: getCutOffPermission } = usePermissionGetter(
    "finance",
    "cutoff_configuration"
  );
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab");

  const [tab, setTab] = React.useState(tabParam || "reimbursementEvoucher");
  const [tabList, setTabList] = React.useState<string[]>([]);
  React.useEffect(() => {
    // setTabList(prevTabList => [...prevTabList, "shopUser"]);
    if (
      getEvoucherPermission("read") &&
      !tabList?.includes("reimbursementEvoucher")
    ) {
      setTabList((prevTabList) => [...prevTabList, "reimbursementEvoucher"]);
    }
    if (
      getPhysicalVoucherPermission("read") &&
      !tabList?.includes("reimbursementPhysicalVoucher")
    ) {
      setTabList((prevTabList) => [
        ...prevTabList,
        "reimbursementPhysicalVoucher",
      ]);
    }
    if (getSalesListingPermission("read") && !tabList?.includes("earnings")) {
      setTabList((prevTabList) => [...prevTabList, "earnings"]);
    }
    if (getCutOffPermission("read") && !tabList?.includes("cutOffDate")) {
      setTabList((prevTabList) => [...prevTabList, "cutOffDate"]);
    }
    // setTab(defaultTab);
  }, [
    getPhysicalVoucherPermission,
    getEvoucherPermission,
    getSalesListingPermission,
    getCutOffPermission,
  ]);

  React.useEffect(() => {
    if (tabParam === null && tabList[0] !== undefined) setTab(tabList[0]);
  }, [tabList]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };
  return (
    <Grid
      sx={{ background: theme.color?.background }}
      borderRadius={"16px"}
      overflow={"hidden"}
    >
      <Grid>
        <Grid
          display={"flex"}
          container
          justifyContent={"space-between"}
          height={"6.25rem"}
          borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
          sx={{
            backgroundColor: theme?.color?.background,
          }}
        >
          <Grid
            item
            display={"flex"}
            px={6}
            gap={2}
            justifyContent={"left"}
            alignItems={"center"}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "600",
                fontFamily: theme.font?.fontFamily.primary,
              }}
            >
              Finance
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          item
          sx={{ background: theme.color?.background }}
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
        >
          <Grid
            item
            borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          >
            <Box ml={7}>
              <Tabs
                TabIndicatorProps={{
                  style: {
                    backgroundColor: theme.color?.secondary,
                  },
                }}
                value={tab}
                onChange={handleChange}
                aria-label="tabs menu"
              >
                {getEvoucherPermission("read") && (
                  <Tab
                    value={"reimbursementEvoucher"}
                    id={"reimbursementEvoucher"}
                    label="Reimbursement e-Voucher"
                    style={{
                      color:
                        tab === "reimbursementEvoucher"
                          ? theme.color?.secondary
                          : undefined,
                      textTransform: "none",
                    }}
                    sx={{
                      marginRight: 3,
                    }}
                  />
                )}
                {getPhysicalVoucherPermission("read") && (
                  <Tab
                    value={"reimbursementPhysicalVoucher"}
                    id={"reimbursementPhysicalVoucher"}
                    label="Reimbursement Physical Voucher"
                    style={{
                      textDecoration: "none",
                      color:
                        tab === "reimbursementPhysicalVoucher"
                          ? theme.color?.secondary
                          : undefined,
                      textTransform: "capitalize",
                    }}
                    sx={{
                      marginRight: 3,
                    }}
                  />
                )}

                {getSalesListingPermission("read") && (
                  <Tab
                    value={"earnings"}
                    id={"earnings"}
                    label="Sales Listing"
                    style={{
                      color:
                        tab === "earnings" ? theme.color?.secondary : undefined,
                      textTransform: "capitalize",
                    }}
                    sx={{
                      marginRight: 3,
                    }}
                  />
                )}

                {getCutOffPermission("read") && (
                  <Tab
                    value={"cutOffDate"}
                    id={"cutOffDate"}
                    label="Cut off Date"
                    style={{
                      color:
                        tab === "cutOffDate"
                          ? theme.color?.secondary
                          : undefined,
                      textTransform: "capitalize",
                    }}
                    sx={{
                      marginRight: 3,
                    }}
                  />
                )}
              </Tabs>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        {(() => {
          switch (tab) {
            case "reimbursementEvoucher":
              return <Evoucher />;
            case "reimbursementPhysicalVoucher":
              return <ReimbursementPhysicalVoucher />;
            case "earnings":
              return <Earnings />;
            case "cutOffDate":
              return <CutOffDate />;
            default:
              return "Error";
          }
        })()}
      </Grid>
    </Grid>
  );
}
